


import Vue from 'vue';

export default Vue.extend({
	name: 'InputUnit',
	props: [
		'id',
		'value',
		'disabled',
		'unit',
	],
});
